import { RECEIVE_REPORT_CONFIGS } from "../actions/reportConfig";

const DEFAULT_STATE = {
  reportConfigs: [],
};

const reportConfigs = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case RECEIVE_REPORT_CONFIGS: {
      return {
        reportConfigs: action.configs,
      };
    }
    default:
      return state;
  }
};

export default reportConfigs;
